<template>
  <div class="edit-street-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>服务收费标准管理</h1>
        <p>服务收费设置</p>
      </div>
    </div>

    <!-- 表单 -->
    <div class="from-wrap">
      <h1>{{ detail.typename }}</h1>
      <div class="from-item mb_85">
        <div class="label"><span class="requird"></span>收费标准，每位陪护人员每小时：</div>
        <div class="input-box">
          <span class="symbole">￥</span>
          <input
            type="number"
            placeholder="请输入"
            maxlength="30"
            v-model="params.price"
          />
        </div>
      </div>
      <div class="from-item form-item-radio mb_85">
        <div class="label"><span class="requird"></span>计费模式：</div>
        <div class="radio-box">
          <div
            class="radio-item flex-between"
            :class="{ active: params.gettype === '1' }"
            @click="handleRadio('1')"
          >
            按服务时长及服务人员数量收费
          </div>
          <div
            class="radio-item flex-between"
            :class="{ active: params.gettype === '2' }"
            @click="handleRadio('2')"
          >
            按单次服务收费
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="fixed-btm flex-rowc">
      <div class="return flex-rowc" @click="handleBack">返回</div>
      <div
        class="add-btn flex-rowc"
        :class="{ disanled: isSubmitting }"
        @click="handleSubmit"
      >
        确认·保存
      </div>
    </div>
  </div>
</template>

<script>
import { addServiceContent, editServiceContent, getServiceContentDetail } from "../../../api/api";
export default {
  name: "EditServiceCharge",
  data() {
    return {
      // 参数
      params: {
        id: "",
        price: '',
        servicetypeid: '',
        gettype: '',
      },
      detail: {},

      isSubmitting: false, // 提交中标记
    };
  },
  created() {
    if (this.$route.query.id) {
      this.params.id = this.$route.query.id;
      // 调用 getServiceContentDetail 方法
      this.getServiceContentDetail();
    }
  },
  methods: {

    // 获取街道详情
    async getServiceContentDetail() {
      const res = await getServiceContentDetail(this.params.id);
      try {
        this.detail = res
        this.params.price = res.price;
        this.params.servicetypeid = res.servicetypeid;
        this.params.gettype = res.gettype;
      } catch (error) {
        console.error("获取街道详情失败:", error);
        this.$toast.fail("获取街道详情失败，请稍后重试");
      }
    },

    // 触发单选框
    handleRadio(item) {
      this.params.gettype = item;
    },
    
    // 返回上一页
    handleBack() {
      this.$router.back();
    },

    // 提交
    async handleSubmit() {
      let { price,} = this.params;
      if (!price) {
        this.$toast("请输入服务收费标准");
        return;
      }

      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      // 设置提交中标记
      this.isSubmitting = true;
      // 显示加载中提示
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let res;
        if (this.params.id) {
          // params.id 存在，调用 editServiceContent 接口
          res = await editServiceContent(this.params);
        } else {
          // params.id 不存在，调用 addServiceContent 接口
          res = await addServiceContent(this.params);
        }

        if (res.result == "true") {
          await new Promise((resolve) => setTimeout(resolve, 400));
          this.$toast.success("提交成功");

          await new Promise((resolve) => setTimeout(resolve, 800));
          // 提交成功后返回上一页
          this.$toast.clear();
          this.$router.back();
          // this.isSubmitting = false;
        } else {
          this.$toast.fail(res.message || "提交失败，请稍后重试");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$toast.fail("提交出错，请稍后重试");
        this.isSubmitting = false;
      } finally {
        // // 无论成功或失败，都关闭加载提示并重置提交状态
        // this.$toast.clear();
        // this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.edit-street-page {
  padding-bottom: 380px;
  box-sizing: border-box;
  .head-wrap {
    width: 700px;
    margin: auto;
    padding: 70px 0 98px 58px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .from-wrap {
    width: 600px;
    margin: auto;
    h1 {
      font-size: 36px;
      margin-bottom: 84px;
      font-weight: bold;
    }
    .from-item {
      .label {
        position: relative;
        font-size: 26px;
        color: #333333;
        padding-left: 12px;
        box-sizing: border-box;
        margin-bottom: 43px;
        .requird {
          width: 15px;
          height: 15px;
          background: url("../../../assets/images/required-icon.png") no-repeat
            center;
          background-size: cover;
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -12px;
        }
      }
      &.form-item-radio {
        .label {
          margin-bottom: 60px;
        }
      }
      .input-box,
      .select-box {
        border-bottom: 1px solid #c3c3c3;
        font-size: 50px;
        // height: 52px;
        padding: 10px 13px;
        box-sizing: border-box;
        color: #FF0000;
        position: relative;
        .symbole {
          font-size: 24px;
          color: #FF0000;
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
        }
        input {
          height: 100%;
          width: 100%;
          background: none;
          text-align: center;
        }
      }
      .radio-box {
        font-size: 24px;
        color: #464646;
        .radio-item {
          width: 495px;
          height: 60px;
          background: #dfe0e7;
          border-radius: 30px;
          margin-bottom: 30px;
          border: 2px solid #dfe0e7;
          padding: 0 22px 0 44px;
          box-sizing: border-box;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          &.active {
            border: 2px solid #0031c9;
            background: #deffff;
            &::after {
              display: inline-block;
              content: "";
              display: inline-block;
              width: 33px;
              height: 23px;
              background: url("../../../assets/images/radio-icon1.png")
                no-repeat center;
              background-size: cover;
            }
          }
        }
      }
    }
    .from-item-address {
      color: #333333;
      .tit {
        font-size: 26px;

        font-weight: bold;
        margin-bottom: 59px;
        padding-left: 19px;
        box-sizing: border-box;
        position: relative;
        &::before {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/address-form-icon.png")
            no-repeat center;
          background-size: cover;
          width: 28px;
          height: 35px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -20px;
        }
      }
      .txt {
        font-size: 26px;
        padding-left: 13px;
        box-sizing: border-box;
        p {
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
    .mb_85 {
      margin-bottom: 85px;
    }
    .mb_75 {
      margin-bottom: 75px;
    }
    .mb_100 {
      margin-bottom: 100px;
    }
    .mb_60 {
      margin-bottom: 60px;
    }
  }
  .fixed-btm {
    position: fixed;
    bottom: 0;
    height: 150px;
    background: #fff;
    z-index: 10;
    align-items: flex-start;
    width: 100%;
    max-width: 750px;
    margin: auto;
    cursor: pointer;
    .return {
      font-size: 24px;
      color: #000000;
      height: 100%;
      width: 150px;
      align-items: flex-start;
      padding-top: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      &::before {
        display: inline-block;
        content: "";
        background: url("../../../assets/images/return-icon.png") no-repeat
          center;
        background-size: cover;
        width: 15px;
        height: 25px;
        margin-right: 8px;
      }
    }
    .add-btn {
      width: 210px;
      height: 50px;
      background: #0031c9;
      border-radius: 25px;
      font-size: 24px;
      color: #fff;
      margin-top: 38px;
      &.disanled {
        background: #d9d9d9;
      }
    }
  }
}
</style>